import React from 'react';
import { ClassroomsProvider } from 'containers/App/context/ClassroomsContext';
import { Outlet } from 'react-router-dom';
import { PageTrackerWrapper } from 'queries/user/track';
import LockedPage from 'components/LockPage/Loadable';
import CahierJournal from './Loadable';
import { RedirectToCurrentDay } from 'containers/CahierJournal/RedirectToCurrentDay';
import { screenshotUrls } from 'containers/screenshotUrls';
import { TitleHelmet } from '../../components/TitleHelmet/TitleHelmet';
import { AuthUserPreview } from './Preview';
import { EventCustomFieldDefinitionsProvider } from 'containers/App/context/EventCustomFieldDefinitionsContext/EventCustomFieldDefinitionsProvider';

export const CahierJournalRoutes = {
  path: 'cahier-journal',
  element: (
    <>
      <TitleHelmet titleKey="sidebar.cahierJournal" />
      <ClassroomsProvider>
        <EventCustomFieldDefinitionsProvider>
          <Outlet />
        </EventCustomFieldDefinitionsProvider>
      </ClassroomsProvider>
    </>
  ),
  children: [
    {
      path: 'locked',
      element: (
        <PageTrackerWrapper title="Cahier journal - nope">
          <LockedPage
            featureKey="cahierjournal"
            s3ImagePath={screenshotUrls.cahierJournal}
          />
        </PageTrackerWrapper>
      ),
    },
    {
      path: ':view/:year/:month/:day',
      children: [
        {
          index: true,
          element: (
            <PageTrackerWrapper title="Cahier journal" enableCJConfigCapture>
              <CahierJournal />
            </PageTrackerWrapper>
          ),
        },
        {
          path: 'preview',
          element: (
            <PageTrackerWrapper title="Cahier journal - preview">
              <AuthUserPreview />
            </PageTrackerWrapper>
          ),
        },
      ],
    },
    {
      index: true,
      element: <RedirectToCurrentDay />,
    },
  ],
};
